import { RouteObject } from "react-router-dom";
import { MY_PROFILE_PATH, MyProfile } from "./pages/my-profile";
import {
  EmployeeProfile,
  EMPLOYEE_PROFILE_PATH,
} from "./pages/employee-profile";

export const profiles: RouteObject[] = [
  {
    path: MY_PROFILE_PATH,
    element: <MyProfile />,
  },
  {
    path: EMPLOYEE_PROFILE_PATH,
    element: <EmployeeProfile />,
  },
];
